export default __webpack_public_path__ + "static/micacloudsbg-4c2aa7915821e9a843c6066431de5aaf.jpg";